export enum PersonType {
  Natural = 'natural',
  Legal = 'legal',
}

export enum GermanLegalForms {
  Aktiengesellschaft = '31',
  AktiengesellschaftUndCoKG = '25',
  AktiengesellschaftUndCoOHG = '26',
  AndereErwerbsOderWirtschaftsgenossenschaft = '49',
  AtypischeStilleGesellschaft = '20',
  AuslaendischeKoerperschaft = '91',
  AuslaendischePersonengesellschaft = '92',
  BergrechtlicheGewerkschaft = '34',
  EuropaeischeAktiengesellschaft = '36',
  EuropaeischeWirtschaftlicheInteressenvereinigung = '28',
  Gebietskoerperschaft = '81',
  GesellschaftDesBuergerlichenRechts = '27',
  GesellschaftMitBeschraenkterHaftung = '35',
  GmbHUndCoKG = '23',
  GmbHUndCoOHG = '24',
  Kolonialgesellschaft = '33',
  Kommanditgesellschaft = '22',
  KommanditgesellschaftAufAktien = '32',
  KreditgenossenschaftNurMitglieder = '41',
  LandwirtschaftlicheNutzungsOderVerwaltungsgenossenschaft = '43',
  NichtrechtsfaehigerVerein = '61',
  OffeneHandelsgesellschaft = '21',
  OeffentlicheOderUnterStaatsaufsichtStehendeSparkasse = '72',
  OeffentlichRechtlicheReligionsgesellschaft = '82',
  OeffentlichRechtlicherVersorgungsVerkehrsOderHafenbetrieb = '74',
  PersonMitBeteiligungenAnGewerblichenPersonengesellschaften = '16',
  Realgemeinde = '44',
  SceEuropaeischeGenossenschaft = '45',
  SonstigeAuslaendischeRechtsform = '99',
  SonstigeJuristischePersonDesPrivatenRechts = '59',
  SonstigeJuristischePersonenDesOeffentlichenRechts = '83',
  SonstigeKapitalgesellschaft = '39',
  SonstigeKreditanstaltDesOeffentlichenRechts = '73',
  SonstigePersonengesellschaft = '29',
  SonstigerBetriebGewerblicherArtVonJuristischenPersonenDesOeffentlichenRechts = '79',
  Staatsbank = '71',
  UnternehmergesellschaftHaftungsbeschraenkt = '37',
  VersicherungsvereinAufGegenseitigkeit = '51',
  ZentralkasseNurMitgliederGenossenschaftlicheAufgaben = '42',
}
